/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Skips_Citations_FootnotesInputs */

const en_funnel_skips_citations_footnotes = /** @type {(inputs: Funnel_Skips_Citations_FootnotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skips citations & footnotes`)
};

const es_funnel_skips_citations_footnotes = /** @type {(inputs: Funnel_Skips_Citations_FootnotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omite citas y notas al pie`)
};

/**
* | output |
* | --- |
* | "Skips citations & footnotes" |
*
* @param {Funnel_Skips_Citations_FootnotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_skips_citations_footnotes = /** @type {((inputs?: Funnel_Skips_Citations_FootnotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Skips_Citations_FootnotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_skips_citations_footnotes(inputs)
	return en_funnel_skips_citations_footnotes(inputs)
});